export enum DateFormat {
	SHORT_DATE, // 15 Jul 2023
	SHORT_DATETIME, // 15 Jul 2023 12:00
	DAY_MONTH_YEAR, // 20/07/2023
	DAY_MONTH_YEAR_HYPHEN, // 2023-07-20
	DAY_MONTH_YEAR_TIME, // 20/07/2023 12:00
	DAY_MONTH_YEAR_TIME_HYPHEN, // 2024-09-30 18:00,
	DAY_MONTH_IN_FULL_YEAR_TIME, // 10 November 2024 18:00,
	TIME,
}

export const formatDate = (dateString: Date | string, format: DateFormat, useLocal = false): string => {
	const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	// Date-only strings like "2026-05-19" are parsed by JS as UTC midnight, which shifts the
	// local date in non-UTC timezones. Reconstruct as local midnight so both paths are consistent.
	let date: Date;
	if (useLocal && typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
		const [y, m, d] = dateString.split('-').map(Number);
		date = new Date(y, m - 1, d);
	} else {
		date = new Date(dateString);
	}

	const day = String(useLocal ? date.getDate() : date.getUTCDate()).padStart(2, '0');
	const monthIndex = useLocal ? date.getMonth() : date.getUTCMonth();
	const month = String(monthIndex + 1).padStart(2, '0');
	const year = useLocal ? date.getFullYear() : date.getUTCFullYear();
	const hours = String(useLocal ? date.getHours() : date.getUTCHours()).padStart(2, '0');
	const minutes = String(useLocal ? date.getMinutes() : date.getUTCMinutes()).padStart(2, '0');
	const locale = sessionStorage.getItem('language') === 'en' ? 'en-GB' : sessionStorage.getItem('language') ?? 'en-GB';

	switch (format) {
		case DateFormat.SHORT_DATE:
			return `${day} ${shortMonthNames[monthIndex]} ${year}`;
		case DateFormat.SHORT_DATETIME:
			return `${day} ${shortMonthNames[monthIndex]} ${year} ${hours}:${minutes}`;
		case DateFormat.DAY_MONTH_YEAR:
			return `${day}/${month}/${year}`;
		case DateFormat.DAY_MONTH_YEAR_HYPHEN:
			return `${year}-${month}-${day}`;
		case DateFormat.DAY_MONTH_YEAR_TIME:
			return `${day}/${month}/${year} ${hours}:${minutes}`;
		case DateFormat.DAY_MONTH_YEAR_TIME_HYPHEN:
			return `${year}-${month}-${day} ${hours}:${minutes}`;
		case DateFormat.DAY_MONTH_IN_FULL_YEAR_TIME:
			return `${new Intl.DateTimeFormat(locale, {
				// 10 November 2024
				day: 'numeric',
				month: 'long',
				year: 'numeric',
				timeZone: 'UTC',
			}).format(date)}`;
		case DateFormat.TIME:
			return `${hours}:${minutes}`;

		default:
			throw new Error('Unsupported date format');
	}
};

export enum Time {
	AM = 'AM',
	PM = 'PM',
}

export const formatTime = (time) => {
	const [hours] = time.split(':').map(Number);
	const ampm = hours >= 12 ? Time.PM : Time.AM;

	return `${time} ${ampm}`;
};
